import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeSectionRead from './cnaeSectionRead.action.json' with { type: 'json' }

const cnaeSectionReadDefinition = defineReadAutoAction(cnaeSectionRead, 'cnaeSection')

export default cnaeSectionReadDefinition
